import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // 初期値をnullに変更
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // ローカルストレージから認証状態を取得
    const storedAuthState = JSON.parse(localStorage.getItem("isAuthenticated"));
    setIsAuthenticated(storedAuthState || false);
    setLoading(false); // 状態の初期化が完了
  }, []);

  const login = () => {
    setIsAuthenticated(true);
    localStorage.setItem("isAuthenticated", JSON.stringify(true));
  };

  const logout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("isAuthenticated");
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
